import { toastr } from 'react-redux-toastr';

export const uploadExcelData = (file, dataCallback) => {
    import('xlsx')
        .then((XLSX) => {
            /* Boilerplate to set up FileReader */
            const reader = new FileReader();
            const rABS = !!reader.readAsBinaryString;
            reader.onload = (e) => {
                /* Parse data */
                const bstr = e.target.result;
                const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array' });
                /* Get first worksheet */
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                /* Convert array of arrays */
                const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
                /* Update state */
                dataCallback(data);
            };
            if (rABS) reader.readAsBinaryString(file); else reader.readAsArrayBuffer(file);
        })
        .catch(err => {
            console.log(err);
            toastr.error('Internal Error');
        });
};

export const exportDataToExcel = (excelName, sheetName, data) => {
    import('xlsx')
        .then((XLSX) => {
            const ws = XLSX.utils.json_to_sheet(data, { sheet: sheetName });
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "SheetJS");

            XLSX.writeFile(wb, `${excelName}.xlsx`);
        })
        .catch(err => {
            console.log(err);
            toastr.error('Internal Error');
        });
};

